<template>

    <div class="eda-profile">

        <div class="eda-profile__username">
            {{ userName }}
        </div>

        <div class="eda-profile__logout">
            <eda-link @click="logout">
                {{ $t('profile.logOut') }}
            </eda-link>
        </div>


        <!-- todo: make sections into one generic component -->
        <div class="eda-profile__section">

            <div>

                <h2 class="eda-profile__h2">
                    {{ $t('profile.retailer.heading') }}
                </h2>
                <div class="eda-profile__retailer eda-profile__value">
                    <span class="eda-profile__retailer-group">
                    {{ retailerGroup.name }}
                    </span>
                    <span class="eda-profile__division" v-if="!editing.retailer">
                        <span class="eda-profile__prefix">
                    {{ $t('profile.retailer.department.heading') }}
                        </span>
                        <span>
                        {{ selectedRetailer.label }}
                        </span>
                    </span>


                    <div class="eda-profile__form" v-if="editing.retailer">
                        <div class="eda-proifle__loader" v-if="!loaded.retailers">
                            <eda-ellipsis-loader></eda-ellipsis-loader>
                        </div>


                        <div class="eda-profile__change-retailer" v-if="loaded.retailers">
                            <eda-styled-select
                                    :legend="$t('chooseRetailer.select.heading')"
                                    :selectedLegend="$t('chooseRetailer.select.legend')"
                                    :searchable="true"
                                    v-model="selectedRetailer"
                                    :options="retailers">
                            </eda-styled-select>
                        </div>
                    </div>
                </div>
            </div>
            <eda-link v-if="!editing.retailer" @click="onClickChangeRetailer()">
                {{ $t('profile.retailer.department.change') }}
            </eda-link>
            <button-pair v-if="editing.retailer"
                         :labels="{secondary: $t('order.edit.cancel'), primary: $t('order.edit.save')}"
                         :loading="{primary: sending.retailer, secondary: false}"
                         :error="{primary: errors.retailer, secondary: false}"
                         @primary-click="saveSelectedRetailer()"
                         @secondary-click="editing.retailer = false">
            </button-pair>


        </div>

        <div class="eda-profile__section">
            <div>
                <h2 class="eda-profile__h2">
                    {{ $t('profile.telephone.heading') }}
                </h2>
                <div class="eda-profile__value" v-if="!editing.telephone">
                    {{ telephone }}
                </div>


                <div v-if="editing.telephone">
                    <eda-styled-input :dark-theme="true" label="Tlf" type="tel"
                                      v-model="telephone"></eda-styled-input>
                </div>


            </div>

            <eda-link v-if="!editing.telephone" @click="editing.telephone = !editing.telephone">
                {{ $t('profile.telephone.change') }}
            </eda-link>

            <button-pair v-if="editing.telephone"
                         :labels="{secondary: $t('order.edit.cancel'), primary: $t('order.edit.save')}"
                         :loading="{primary: sending.telephone, secondary: false}"
                         :error="{primary: errors.telephone, secondary: false}"
                         @primary-click="saveTelephone"
                         @secondary-click="editing.telephone = false">
            </button-pair>

        </div>

        <div class="eda-profile__section">
            <div>
                <h2 class="eda-profile__h2">
                    {{ $t('profile.password.heading') }}
                </h2>
                <div class="eda-profile__value" v-if="!editing.password">
                    ***********
                </div>


                <div v-if="editing.password">
                    <eda-styled-input :dark-theme="true"
                                      :label="$t('profile.password.heading')"
                                      type="password"
                                      v-model="newPassword"/>
                </div>


            </div>

            <eda-link
                    v-if="!editing.password"
                    @click="editing.password = !editing.password">
                {{ $t('profile.password.change')}}
            </eda-link>

            <button-pair v-if="editing.password"
                         :labels="{secondary: $t('order.edit.cancel'), primary: $t('order.edit.save')}"
                         :loading="{primary: sending.password, secondary: false}"
                         :error="{primary: errors.password, secondary: false}"
                         @primary-click="saveNewPassword"
                         @secondary-click="editing.password = false"/>

        </div>


    </div>


</template>

<script>
  import EdaStyledInput from '../components/vInput'
  import EdaLink from '../components/vLink'
  import EdaStyledSelect from '../components/vSelect'
  import ButtonPair from '../components/vButtonPair'
  import { mapGetters } from 'vuex'
  import { mapActions } from 'vuex'
  import EdaEllipsisLoader from "../components/vEllipsisLoader";
  import axios from "axios";
  import api from "../mixins/apiMixin";
  import _ from "lodash";

  export default {
    name: "eda-edit-profile",
    components: {
      EdaEllipsisLoader,
      EdaStyledInput,
      EdaLink,
      EdaStyledSelect,
      ButtonPair
    },
    mixins: [api.apiMixin],
    data() {
      let retailer = this.$store.state.user.user.retailer;
      return {
        retailers: [],
        newPassword: "",
        telephone: "",
        selectedRetailer: { label: retailer.name, id: retailer.id },

        loaded: {
          retailers: false
        },

        editing: {
          telephone: false,
          retailer: false,
          password: false,
        },
        errors: {
          telephone: false,
          retailer: false,
          password: false,
        },
        sending: {
          telephone: false,
          retailer: false,
          password: false,
        }

      }

    },
    mounted() {
      this.loadUser();
    },
    computed: {
      ...mapGetters([
          'getUser'
        ]
      ),
      retailerGroup() {
        let retailerGroup = _.get(this.$store.state, 'user.user.retailer.group', {});
        return retailerGroup;
      },
      userName() {
        return this.getUser.fullName.length ? this.getUser.fullName : this.getUser.email;

      }
    },



    methods: {
      ...
        mapActions([
          'clearState',
          'setRetailer',
          'setUser'
        ]),

      onClickChangeRetailer() {
        this.editing.retailer = true;
        this.loadRetailers();
      },


      saveSelectedRetailer() {
        var that = this;
        that.errors.retailer = false;
        that.sending.retailer = true;
        axios.patch(process.env.VUE_APP_API_URL + "/users/me", {
          "retailerPortals": [that.selectedRetailer.id],
        }, that.apiHeaders).then(function (response) {
          that.setUser(response.data);
          that.editing.retailer = false;
        }).catch(function (error) {
          that.errors.retailer = true;
          console.log(error.response)
        }).finally(function () {
          that.sending.retailer = false;
        });
      },

      saveTelephone() {
        var that = this;
        that.errors.telephone = false;
        that.sending.telephone = true;
        axios.patch(process.env.VUE_APP_API_URL  + "/users/me",
          { "telephoneNumber": that.telephone },
          that.apiHeaders
        ).then(function (response) {
          that.editing.telephone = false;
          that.setUser(response.data);
        }).catch(function (error) {
          that.errors.telephone = true;
        }).finally(function () {
          that.sending.telephone = false;
        });
      },

      saveNewPassword() {
        var that = this;
        that.errors.password = false;
        that.sending.password = true;
        axios.patch(process.env.VUE_APP_API_URL + "/users/me",
          { "newPassword": that.newPassword },
          that.apiHeaders
        ).then(function (response) {
          that.setUser(response.data);
          that.editing.password = false;
        }).catch(function (error) {
          that.errors.password = true;
        }).finally(function () {
          that.sending.password = false;
        });
      },

      loadUser() {
        var that = this;
        axios.get(process.env.VUE_APP_API_URL + "/users/me", that.apiHeaders).then(function (response) {
          that.setUser(response.data);
          that.telephone = response.data.telephone;
        });
      },

      loadRetailers() {
        var that = this;
        axios.get(process.env.VUE_APP_API_URL  + "/retailers/" + that.retailerGroup.handle, that.apiHeaders).then(function (response) {
          that.retailers = [];
          var response = response.data.data;
          for (var index in response) {
            that.retailers.push(that.transformRetailer(response[index]))
          }
          that.loaded.retailers = true;
        }).catch(function (error) {
        });
      }
      ,

      transformRetailer(retailer) {
        return { label: retailer.name, id: retailer.id }
      }
      ,


      logout() {
        this.clearState();
        this.$router.push("/");
      }
      ,
      get(key) {
        return this.getField({ store: "user", key: key });
      }
    }
  }
</script>

<style>


    .eda-profile {
        color: white;
        max-width: 45em;
        margin: 0 auto;
    }

    .eda-profile__section {
        width: 100%;
        padding: 2em;
        border-bottom: 1px solid #222722;
        display: flex;
        flex-wrap: wrap;
        align-items: flex-end;
        justify-content: space-between;
    }

    .mq-mobile .eda-profile__section {
        flex-direction: column;
        font-size: 0.9em;
        align-items: flex-start;
        padding: 1em
    }

    .eda-profile__retailer {
        display: flex;
        align-items: center;
    }

    .mq-mobile .eda-profile__retailer {
        flex-direction: column;
        align-items: flex-start;

    }

    .eda-profile__form {
        padding: 0 1em;
        margin: -1em 0;
        font-size: 0.8em;
        width: 100%;
    }

    .eda-profile__division {
        font-size: 0.9em;
        margin-left: 1em;
    }

    .mq-mobile .eda-profile__division {
        margin-left: 0;
        padding: .25em 0 1em 0;

    }

    .eda-profile__prefix {
        padding-right: 0.25em;
        font-weight: 600;
    }

    .eda-profile__username {
        font-size: 2em;
        width: 100%;
        text-align: center;
        padding-bottom: 0.5em;
        color: white;
        font-weight: 400;
        padding: 2em 1em 0.5em 1em;
        font-size: 2em;
        position: relative;
        transition: 0.2s ease all;
    }

    .mq-tablet .eda-profile__username,
    .mq-mobile .eda-profile__username {
        font-size: 1.5em;
    }

    .eda-profile__value {
        font-weight: 300;
        font-size: 1.25em;
    }

    .eda-profile__logout {
        padding: 1em;
        display: flex;
        justify-content: center;
    }

    .eda-profile__h2 {

        font-size: 0.9em;
        font-weight: 400;
        color: white;
    }

</style>